import { Check } from "lucide-react";
import AnimateOnScroll from "./AnimateOnScroll";

const steps = [
  {
    number: "01",
    title: "Connect your site",
    description: "Add a single script to your website. The agent scans your pages, detects your industry, and understands your content.",
    features: ["Works with any platform", "Auto-detects structure", "No performance impact"],
  },
  {
    number: "02",
    title: "Set your goal",
    description: "Tell the agent what you want: more sales, more leads, lower bounce rate. It builds a personalized strategy for you.",
    features: ["Natural language goals", "AI-generated strategy", "Ready in minutes"],
  },
  {
    number: "03",
    title: "The agent does the rest",
    description: "It creates campaigns, personalizes content, runs A/B tests, and optimizes automatically. You just review the results.",
    features: ["Autonomous optimization", "24/7 monitoring", "Full audit trail"],
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        {/* Header */}
        <AnimateOnScroll>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-tight">
              How it works
            </h2>
            <p className="text-lg text-muted-foreground">
              From zero to optimized in 3 steps. No developers, no complexity.
            </p>
          </div>
        </AnimateOnScroll>

        {/* Steps */}
        <div className="max-w-3xl mx-auto space-y-8">
          {steps.map((step, index) => (
            <AnimateOnScroll key={index} delay={index * 150}>
              <div className="flex gap-6 md:gap-8">
                {/* Number */}
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-foreground text-background flex items-center justify-center font-semibold text-sm">
                    {step.number}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 pb-8 border-b border-border last:border-0">
                  <h3 className="text-xl font-semibold text-foreground mb-2">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    {step.description}
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {step.features.map((feature, featureIndex) => (
                      <div
                        key={featureIndex}
                        className="flex items-center gap-1.5 text-sm text-muted-foreground"
                      >
                        <Check className="w-4 h-4 text-foreground" />
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
